import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _authorizeRequest = {};
var _deviceCodeRequest = {};
var _deviceCodeResponse = {};
var _deviceVerifyRequest = {};
var _deviceVerifyResponse = {};
var _invalidateUserCodeRequest = {};
var _invalidateUserCodeResponse = {};
var _rawHttpRequest = { body: 'BYTES' };
var _rawHttpResponse = { body: 'BYTES' };
var _revokeRefreshTokenRequest = {};
var _revokeRefreshTokenResponse = {};
function resolveWixIdentityOauth2V1Oauth2NgUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/oauth2',
                destPath: '/v1/oauth',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/oauth2',
                destPath: '/v1/oauth',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/v1/oauth/device/verify',
                destPath: '/v1/oauth/device/verify',
            },
            {
                srcPath: '/v1/oauth/manage/user-code',
                destPath: '/v1/oauth/manage/user-code',
            },
        ],
        _: [
            {
                srcPath: '/_api/oauth2',
                destPath: '/v1/oauth',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function authorize(payload) {
    var _a = serializer(_authorizeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __authorize(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'GET',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.Authorize',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/authorize',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __authorize.fromReq = fromReq;
    __authorize.__isAmbassador = true;
    return __authorize;
}
/**
 * Token endpoint accepts the TokenRequest message encoded in the raw http request body, and returns either
 * TokenResponse(status code = 200) or TokenErrorResponse (status code = 4XX) encoded in the raw http response body.
 */
export function token(payload) {
    var _a = serializer(_rawHttpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __token(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'POST',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.Token',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/token',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __token.fromReq = fromReq;
    __token.__isAmbassador = true;
    return __token;
}
/** this endpoint serves the Device Authorization Flow as described in https://www.rfc-editor.org/rfc/pdfrfc/rfc8628.txt.pdf */
export function deviceCode(payload) {
    var _a = serializer(_deviceCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deviceCodeResponse, {}).fromJSON;
    function __deviceCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'GET',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.DeviceCode',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/device/code',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deviceCode.fromReq = fromReq;
    __deviceCode.__isAmbassador = true;
    return __deviceCode;
}
/** this endpoint serves the Device Authorization Flow as described in https://www.rfc-editor.org/rfc/pdfrfc/rfc8628.txt.pdf */
export function deviceVerify(payload) {
    var _a = serializer(_deviceVerifyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deviceVerifyResponse, {}).fromJSON;
    function __deviceVerify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'GET',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.DeviceVerify',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/device/verify',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deviceVerify.fromReq = fromReq;
    __deviceVerify.__isAmbassador = true;
    return __deviceVerify;
}
/**
 * Invalidate a user code created by the DeviceCode endpoint. Only the creating
 * If a refresh token was created from this user code recently (time frame is configurable) this endpoint shall revoke
 * it in a similar fashion to RevokeRefreshToken.
 */
export function invalidateUserCode(payload) {
    var _a = serializer(_invalidateUserCodeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_invalidateUserCodeResponse, {}).fromJSON;
    function __invalidateUserCode(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'DELETE',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.InvalidateUserCode',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/manage/user-code',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __invalidateUserCode.fromReq = fromReq;
    __invalidateUserCode.__isAmbassador = true;
    return __invalidateUserCode;
}
/** Revoke a refresh token created by this service. */
export function revokeRefreshToken(payload) {
    var _a = serializer(_revokeRefreshTokenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_revokeRefreshTokenResponse, {}).fromJSON;
    function __revokeRefreshToken(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.oauth.v1.refresh_token',
            method: 'POST',
            methodFqn: 'wix.identity.oauth2.v1.Oauth2Ng.RevokeRefreshToken',
            url: resolveWixIdentityOauth2V1Oauth2NgUrl({
                protoPath: '/v1/oauth/revoke',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __revokeRefreshToken.fromReq = fromReq;
    __revokeRefreshToken.__isAmbassador = true;
    return __revokeRefreshToken;
}
//# sourceMappingURL=http.impl.js.map